import { useConfigStore } from '@/stores/configStore';
import { TOGGLE_TYPE_ALL_CATEGORY_ID, type ToggleTypeCategoryItem } from '@/types/toggle-type';
import { useTranslation } from 'react-i18next';

export const useCategoryList = (id?: string): ToggleTypeCategoryItem[] => {
    const { t } = useTranslation();
    const language = useConfigStore((state) => state.config.ui.language);
    const listBuildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);
    const buildingMenus = listBuildingMenus?.[language];
    if (!id) return [];

    const menu = buildingMenus?.find((item) => item.id === id);
    const customContent = menu?.customContent ?? [];
    const customMenus =
        menu?.customMenuCategory
            ?.filter((category) => customContent.some((item) => String(item.categoryId) === String(category.id)))
            .map((item) => ({
                id: String(item.id),
                name: typeof item.name === 'string' ? item.name : '',
            })) || [];

    return [
        {
            id: TOGGLE_TYPE_ALL_CATEGORY_ID,
            name: t('common.text.all_category'),
        },
        ...customMenus,
    ];
};
